import React from 'react';
import { Spinner } from '../../Loaders';
import { GridStyled } from 'src/styles/layout';
import { useUrlParameterCheck } from 'src/utils/useUrlParameterCheck';
import { t } from 'i18next';

interface ICardLoaderProps {
  type?: string;
}

export const CardLoader = (props: ICardLoaderProps) => {
  const isFromMvpApp = useUrlParameterCheck('/app');
  const text = props.type === 'Updating' ? t('Processing') : null;

  return (
    <GridStyled
      style={{
        display: isFromMvpApp ? 'flex' : '',
        alignItems: isFromMvpApp ? 'center' : '',
        marginTop: isFromMvpApp ? 'auto' : '',
        marginBottom: isFromMvpApp ? 'auto' : '',
      }}
      container
      padding={20}
      justifyContent="center"
      {...props}
    >
      <GridStyled item style={{ textAlign: 'center' }}>
        <Spinner />
        {isFromMvpApp && <p style={{ fontSize: '24px' }}>{text}</p>}
      </GridStyled>
    </GridStyled>
  );
};
